<template>
  <b-container>
    <b-table :fields="fields" :items="stats" show-empty> </b-table>
  </b-container>
</template>

<script>
export default {
  name: "playerstats",
  props: ["stats", "config"],
  data() {
    return {
      fields: [
        { key: "stats_name", label: "Stats" },
        { key: "pos", label: "Position" },
        { key: "value", label: "Total/Avg" },
        { key: "rh_played", label: "Rounds", class: 'RoundsRemove' },
        { key: "played", label: "Tournaments" }

      ]
    };
  }
};
</script>

<style scoped>

::v-deep thead>tr>th{
  text-align: left;
  padding: 8px;
  color: #fff;
  font-size: 13px;
  font-weight: 400;
  border-top: 0px solid #dee2e6!important;
  font-size: 13px;
  text-transform: capitalize;
  padding: 0.75rem;
}
::v-deep thead>tr{
  background-color: #93278f!important;
  color: white;
}
::v-deep tbody>tr>td{
  text-align: left;
  padding: 8px;
  /* border-top: 1px solid #fff; */
  font-size: 13px;
  color: #6C6C6C;
}
::v-deep tbody>tr{
    /* background-color: rgba(0,0,0,.05); */
}

::v-deep th:first-child{
  text-align: left;
}
::v-deep td:first-child{
  text-align: left;
  color: #f8635f;
  font-weight: 500;
  font-size: 13px;
}

::v-deep td:last-child{
  color: #3C3C3C;
  font-weight: 700;
}

@media only screen and (max-width: 768px) {
  ::v-deep th.RoundsRemove {
    display: none;
  }
  ::v-deep td.RoundsRemove {
    display: none;
  }
}
</style>
